<template>
  <div>
    <form @submit.prevent="handleOk">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="md"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <font-awesome-icon icon="bars" />
          <span class="pl-2">
            {{ input ? 'Edit' : 'Add' }} Menu Group Limit
          </span>
        </div>
        <div>
          <b-container>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Outlet Code</label>
              </b-col>
              <b-col md="9" :class="{'form-error': errors.first('outletCode')}">
                <b-form-input
                  v-model="obj.outletCode"
                  v-validate="'required|alpha_num'"
                  name="outletCode"
                  type="text"
                />
                <small>{{ errors.first('outletCode') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Menu Group Code</label>
              </b-col>
              <b-col md="9" :class="{'form-error': errors.first('menuGroupCode')}">
                <b-form-input
                  v-model="obj.menuGroupCode"
                  v-validate="'required|alpha_num'"
                  name="menuGroupCode"
                  type="text"
                />
                <small>{{ errors.first('menuGroupCode') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="3">
                <label>Order Type</label>
              </b-col>
              <b-col md="9" :class="{'form-error': errors.first('orderType')}">
                <b-form-input
                  v-model="obj.orderType"
                  v-validate="'required|alpha_num'"
                  name="orderType"
                  type="text"
                />
                <small>{{ errors.first('orderType') }}</small>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn type="submit" variant="success">
            <font-awesome-icon icon="save" />
            {{ input ? 'Update' : 'Save' }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            <font-awesome-icon icon="times" />Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>
<script>
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

export default {
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      obj: {}
    };
  },

  methods: {
    // add and update records
    handleOk(evt) {
      this.$validator.validate().then(valid => {
        if (valid) {
          evt.preventDefault();
          if (this.input === null) {
            this.$store
              .dispatch('CreateMenuGroupLimit', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  'Record is created'
                );
                if (res) {
                  this.$emit('discard-modal', true);
                  this.reset();
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          } else {
            this.$store
              .dispatch('UpdateMenuGroupLimit', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  constants.RECORD_IS_UPDATED
                );
                if (res) {
                  this.$emit('discard-modal', true);
                  this.reset();
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          }
        }
      });
    },
    discardModal() {
      this.reset();
      this.$emit('discard-modal');
    },

    // reset input fields
    reset() {
      if (this.input == null) {
        this.obj = {
          id: '',
          outletCode: '',
          menuGroupCode: '',
          orderType: ''
        };
      } else {
        this.obj = this.input;
      }
    }
  }
};
</script>
